module.exports = __webpack_public_path__ + "static/products-804810bc6c8426044faccccfc1579c14.png";